import { DateTime } from "luxon";
import { getLocale } from "./getLocale";
import { ISODateString } from "@novel/shared/interfaces/shared/ISODateString";

const timeConfigObj = {
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "shortGeneric",
};

export function toViewDate(
    date: ISODateString | Date | DateTime,
    options: Intl.DateTimeFormatOptions = {},
) {
    // hacky but more annoying if we can't accept "ISODateString", this will work
    const castedDate =
        typeof date === "string" ? ISODateString.fromString(date) : (date as Date | DateTime);

    const inputDate: Date = castedDate instanceof DateTime ? castedDate.toJSDate() : castedDate;

    return new Intl.DateTimeFormat(getLocale(), options).format(inputDate);
}

export function toViewDateWithoutDate(
    date: ISODateString | Date | DateTime,
    withTime = false,
): string {
    try {
        const options = {
            year: "numeric",
            month: "long",
            day: "numeric",
            ...(withTime ? timeConfigObj : {}),
        };

        // options not up to date in core typescript def yet (works in all browsers though)
        return toViewDate(date, options as any);
    } catch (e) {
        return toViewDate(new Date()); // just in case dateStyle property fails in an old browser
    }
}

export function toViewLongDate(date: ISODateString | Date | DateTime, withTime = false): string {
    try {
        const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            ...(withTime ? timeConfigObj : {}),
        };

        // options not up to date in core typescript def yet (works in all browsers though)
        return toViewDate(date, options as any);
    } catch (e) {
        return toViewDate(new Date()); // just in case dateStyle property fails in an old browser
    }
}

export function toViewShortDate(date: ISODateString | Date | DateTime, withTime = false): string {
    // options not up to date in core typescript def yet (works in all browsers though)
    return toViewDate(date, {
        day: "numeric",
        month: "numeric",
        year: "2-digit",
        ...(withTime ? timeConfigObj : {}),
    } as any);
}
